import { SORTING_PROFILES } from '../constants'

export const createProfileSelectOptions = (sortingProfiles) =>
    sortingProfiles.map((value) => ({
        value,
        label: SORTING_PROFILES[value],
    }))
